import React, { forwardRef } from 'react';

import InputTemplate from '../TemplateNumberFormatInput';

const IntegerInput = forwardRef((props, ref) => <InputTemplate {...props} ref={ref} />);

export default IntegerInput;
